import { Button as MuiButton, ButtonProps as MuiButtonProps } from "@mui/material";

export type ButtonProps = MuiButtonProps & {};
export const Button = (props: any) => {
  return <MuiButton variant="contained" size="large" {...props} />;
};
